import React, { useEffect } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { getPrayerWallItems } from "features/sidebar/sidebarSlice";
import Loader from "loaders/Loader";
import PrayerWallItem from "./PrayerWallItem";
import SpinnerSmall from "components/SpinnerSmall";
import { useTranslation } from "react-i18next";

export default function PrayerWallFeed(props) {
  const { t } = useTranslation("prayer");

  const dispatch = useDispatch();
  const { viewSidebar, prayerWallItems, getPrayerWallItemsStatus } =
    useSelector((state) => state.sidebar);

  const { profileChurch } = useSelector((state) => state.profileChurch);

  useEffect(() => {
    if (viewSidebar === "prayerWall" && profileChurch._id) {
      dispatch(
        getPrayerWallItems({
          churchId: profileChurch._id,
        }),
      );
    }
  }, [viewSidebar, profileChurch._id]);

  return (
    <PrayerWallFeedContainer>
      {getPrayerWallItemsStatus === "LOADING" ? (
        <SpinnerSmall border="#727272" />
      ) : getPrayerWallItemsStatus === "SUCCESS" &&
        prayerWallItems &&
        prayerWallItems.length > 0 ? (
        prayerWallItems.map((item, index) => {
          return <PrayerWallItem key={index} item={item} />;
        })
      ) : (
        <div>{t("wall.empty")}</div>
      )}
    </PrayerWallFeedContainer>
  );
}

const PrayerWallFeedContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 150px);
  overflow-y: scroll;
  background-color: var(--lightThemeBackground);
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
